import React, { useState } from 'react';
import { FaLock } from 'react-icons/fa';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';
import styles from './PaymentForm.module.css';

export default function PaymentForm({ amount, currency }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const formattedAmount = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount / 100);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!stripe || !elements) return;

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin + '/payment-status',
      },
      redirect: 'if_required'
    });

    if (error) {
      setError('Payment failed. Please try again - you have not been charged');
      setLoading(false);
    } else if (paymentIntent?.status === 'succeeded') {
      navigate('/view');
    }
  };

  return (
    <div className={styles.paymentPage}>
      <img src="/payment.jpg" alt="Payment" className={styles.mascotImage} />
      <h1 className={styles.title}>Broadcast Access</h1>
      <p className={styles.description}>Broadcasts require a one-time payment of <strong>{formattedAmount}</strong> to access</p>
      <p className={styles.description}>Please enter your payment details below to continue.</p>

      <form onSubmit={handleSubmit} className={styles.paymentForm}>
        <div className={styles.cardElementWrapper}>
          <PaymentElement options={{ layout: 'accordion' }} />
        </div>
        <p className={styles.securityNote}>
          <strong><FaLock /></strong> Your payment is processed securely by <strong>Stripe</strong>. We never store your card details.
        </p>
        {error && <p className={styles.error}>{error}</p>}
        <button
          type="submit"
          className={`${styles.payButton} ${styles.desktopOnly}`}
          disabled={!stripe || loading}
        >
          {loading ? 'Processing...' : 'Pay Now'}
        </button>
      </form>

      {/* Mobile-only sticky footer */}
      <div className={`${styles.stickyFooter} ${styles.mobileOnly}`}>
        <button
          type="submit"
          className={styles.payButton}
          disabled={!stripe || loading}
          onClick={handleSubmit}
        >
          {loading ? 'Processing...' : 'Pay Now'}
        </button>
      </div>

    </div>
  );
}
